<mat-label style="color: blue" *ngIf="fileSelected"
  >{{ selectedFile.file.name }} <button style="color: red" mat-button><mat-icon>delete</mat-icon></button>
</mat-label>

<div class="modhyobitto-file-uploader" >
  <div class="file-upload__options">
    <form [formGroup]="fileSelectionForm">
      <label for="fileSelector" class="file-upload__label">
        <span class="file-upload__label-text">{{ 'DRIVER_IMPORT.selectFileCsv' | translate }}</span>
        <mat-icon class="material-icons-outlined" [style.color]="'#' + cService.userProfile?.HqColour"
          >cloud_upload</mat-icon
        >
      </label>
      <input
        id="fileSelector"
        type="file"
        #fileSelector
        formControlName="file_selection"
        [accept]="'txt,csv'"
        (change)="handleFileInput($event)"
      />
    </form>
  </div>
</div>
